/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import Svg from 'rp-react-svg-icon';

/**
 * Component that is used for rendering <NewsError />
 * It tells that some problem occurs during to retrieving news
 */
const NewsError = () => (
    <div className="rh-news__errorsHandle ui-errorMessage">
        <Svg isInlined iconName="results" selector="img-errorMessageImage" />
        <div className="ui-errorMessage__container" data-test-selector="text-errorMessageText">
            <h3 className="ui-errorMessage__title">Your Racing Post news service</h3>
            <span className="ui-errorMessage__text">
                There&apos;s a technical problem that means
                the news and tipping sections of racingpost.com are unavailable.
                We are working to resolve this and expect service to return to normal shortly.
                Apologies for any inconvenience this has caused.
            </span>
        </div>
    </div>
);

export { NewsError as default };



// WEBPACK FOOTER //
// ./src/js/News/components/NewsError/NewsError.js